import { create } from "zustand";

export type ToastTone = "ok" | "err" | "info";

export interface Toast {
  id: number;
  tone: ToastTone;
  message: string;
}

interface ToastState {
  toasts: Toast[];
  push: (tone: ToastTone, message: string) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (tone, message) => {
    const id = nextId++;
    set((s) => ({ toasts: [...s.toasts, { id, tone, message }] }));
    // Auto-dismiss after a few seconds; errors linger a little longer.
    const ttl = tone === "err" ? 6000 : 3500;
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), ttl);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** Imperative helpers usable outside React (e.g. the query-client error handler). */
export const toast = {
  ok: (m: string) => useToastStore.getState().push("ok", m),
  err: (m: string) => useToastStore.getState().push("err", m),
  info: (m: string) => useToastStore.getState().push("info", m),
};
